import client from './client.json';
import server from './server.json';

export default {
  ...client,
  ...server,
};
